import { useSearchParams } from 'react-router';

import type { LetterType } from '@/apps/engagement-letter-database/data/types';
import { useEngagementRecords, useWaiverRecords } from '@/apps/engagement-letter-database/store';

import DashboardDataGrid from './components/DashboardDataGrid';
import HeaderPane from './components/HeaderPane';

function HomeDashboard() {
  const [searchParams, setSearchParams] = useSearchParams();
  const letterType = (searchParams.get('letterType') as LetterType) || 'engagement';

  useEngagementRecords();
  useWaiverRecords({ enabled: letterType === 'waiver' });

  const handleLetterTypeChange = (value: LetterType) => {
    setSearchParams((prev) => {
      if (value === 'engagement') {
        prev.delete('letterType');
      } else {
        prev.set('letterType', value);
      }
      return prev;
    });
  };

  return (
    <>
      <HeaderPane letterType={letterType} onLetterTypeChange={handleLetterTypeChange} />
      <DashboardDataGrid letterType={letterType} />
    </>
  );
}

export default HomeDashboard;
